import { datePickerSharedProps as e, selectionModeWithDefault as o } from "./index935.js";
import { buildProps as r } from "./index601.js";
const a = r({
  ...e,
  selectionMode: o("year")
});
export {
  a as basicYearTableProps
};
